import { TXN_REASON, TXN_REASONS_TEXT } from '../enrollmentList/enrollmentList.constant';

const TEXTAREA_MAX_LENGTH = 4000;
const TEXTAREA_MIN_LENGTH = 1;

const REASON_FOR_CANCEL_OPTIONS = [
    {
        value: TXN_REASON.AI,
        text: TXN_REASONS_TEXT.NO_REASON_GIVEN,
    },
    {
        value: TXN_REASON.FiftyNine,
        text: TXN_REASONS_TEXT.NON_PAYMENT,
    },
    {
        value: TXN_REASON.Fourteen,
        text: TXN_REASONS_TEXT.VOLUNTARY_WITHDRAWAL,
    },
    {
        value: TXN_REASON.ZeroThree,
        text: TXN_REASONS_TEXT.DEATH,
    },
];

const NO_PAYMENT_VALUE = REASON_FOR_CANCEL_OPTIONS[1].value; //retuening 59 value

const REINSTATEMENT_STATUS = {
    CANNOT_REINSTATED: 'CANNOT_REINSTATED',
    SUBSEQUENT_APP_SUBMITTED: 'SUBSEQUENT_APP_SUBMITTED',
};

export { NO_PAYMENT_VALUE, REASON_FOR_CANCEL_OPTIONS, REINSTATEMENT_STATUS, TEXTAREA_MAX_LENGTH, TEXTAREA_MIN_LENGTH };
